import type { Theme } from "@mui/material";

export type inputVariant = "standard" | "outlined";
export type textDecoration = "line-through";

export function commonInputStyles(
    theme: Theme,
    variant: inputVariant | undefined,
    alwaysShowUnderline: boolean,
    textDecoration: textDecoration | undefined,
    multiline?: boolean
) {
    const fontSize = 14;
    return {
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.grey.A400,
            fontSize: theme.typography.pxToRem(fontSize),
        },
        "& .MuiInputBase-root.MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before": {
            borderBottom: "1px solid #b4b4b4",
            borderBottomColor: "#b4b4b4",
        },
        "& .MuiInputBase-root.MuiInput-root::before": {
            transition: "none",
        },
        "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.grey.A400,
        },
        "& .MuiFormLabel-root": {
            fontSize: variant === "standard" ? theme.typography.pxToRem(16) : undefined,
            fontWeight: variant === "standard" ? theme.typography.fontWeightBold : undefined,
            whiteSpace: multiline ? "normal" : "nowrap",
            "&.MuiInputLabel-shrink": {
                whiteSpace: "nowrap",
            },
        },
        "& .MuiInputBase-input": {
            fontSize: theme.typography.pxToRem(fontSize),
            textDecoration: textDecoration,
        },
        "& .MuiInputBase-root::before": {
            border: alwaysShowUnderline ? undefined : 0,
        },
        "& .MuiFormLabel-root.Mui-disabled": {
            color: theme.palette.text.disabled,
        },
    };
}
